import {
  GROVE_ICONS,
  type GroveIcon as GroveIconName,
} from '@goaltree/backend/convex/lib/groveIcons'
import { cn } from '@goaltree/ui/lib/utils'
import {
  Bike,
  BookOpen,
  Brain,
  Dumbbell,
  Flame,
  Flower2,
  Footprints,
  Heart,
  Leaf,
  type LucideIcon,
  Mountain,
  Sprout,
  Sun,
  Trees,
  Trophy,
  Users,
  Zap,
} from 'lucide-react'

const ICONS: Record<GroveIconName, LucideIcon> = {
  trees: Trees,
  sprout: Sprout,
  leaf: Leaf,
  'flower-2': Flower2,
  mountain: Mountain,
  sun: Sun,
  flame: Flame,
  zap: Zap,
  footprints: Footprints,
  dumbbell: Dumbbell,
  bike: Bike,
  'book-open': BookOpen,
  brain: Brain,
  heart: Heart,
  users: Users,
  trophy: Trophy,
}

const SIZES = {
  xs: 'size-6 rounded-lg [&>svg]:size-3.5',
  sm: 'size-12 rounded-2xl [&>svg]:size-6',
  md: 'size-14 rounded-2xl [&>svg]:size-7',
  lg: 'size-20 rounded-3xl [&>svg]:size-10',
}

export function GroveIcon({
  icon,
  size = 'md',
  className,
}: {
  icon: string
  size?: keyof typeof SIZES
  className?: string
}) {
  const Icon = ICONS[icon as GroveIconName] ?? Trees
  return (
    <div
      aria-hidden
      className={cn(
        'flex shrink-0 items-center justify-center bg-primary/10 text-primary-text',
        SIZES[size],
        className,
      )}
    >
      <Icon strokeWidth={2.2} />
    </div>
  )
}

export function GroveIconPicker({
  value,
  onChange,
}: {
  value: string
  onChange: (icon: string) => void
}) {
  return (
    <div className="grid grid-cols-8 gap-1.5">
      {GROVE_ICONS.map((name) => {
        const Icon = ICONS[name]
        const active = value === name
        return (
          <button
            key={name}
            type="button"
            aria-label={name}
            aria-pressed={active}
            onClick={() => onChange(name)}
            className={cn(
              'flex aspect-square cursor-pointer items-center justify-center rounded-xl border transition-colors',
              active
                ? 'border-primary bg-primary/10 text-primary-text'
                : 'border-border/60 bg-muted/20 text-muted-foreground hover:bg-muted/50 hover:text-foreground',
            )}
          >
            <Icon className="size-[18px]" strokeWidth={2.2} />
          </button>
        )
      })}
    </div>
  )
}
